import { DataGridTable } from "./DXTable.styles";
import { CustomCheckbox } from "./CustomCheckbox";

interface TableProps {
  checkboxField: boolean;
  rows: any[];
  columns: any[];
  className?: string;
}

const renderRoleCell = (params) => {
  const role = params.value;
  const className = role === "Invited" ? 'italic-role' : '';
  return <span className={className}>{role}</span>;
};

export default function DxTable({
  checkboxField,
  rows,
  columns,
  className,
}: TableProps) {

  const updatedColumns = columns.map((column) => {
    if (column.field === 'role') {
      return {
        ...column,
        renderCell: renderRoleCell,
      };
    }
    return column;
  });

  return (
    <div style={{ width: "100%" }}>
      <DataGridTable
        rows={rows}
        columns={updatedColumns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        components={{
          BaseCheckbox: CustomCheckbox,
        }}
        pageSizeOptions={[5, 10, 25, 50]}
        checkboxSelection={checkboxField}
        className={className}
      />
    </div>
  );
}